module.exports = __webpack_public_path__ + "static/media/wicket-keeper-icon.362da973.svg";